export const EMAIL_LOGIN_LABELS = {
  BUTTON_TEXT: 'Use Email or Username',
  MODAL_TITLE: 'Sign in with your email',
  MODAL_SUBTITLE: 'Enter your email or username and password to continue.',
  EMAIL_LABEL: 'Email or Username',
  EMAIL_PLACEHOLDER: 'name@example.com',
  PASSWORD_LABEL: 'Password',
  PASSWORD_PLACEHOLDER: '••••••••',
  CANCEL_BUTTON: 'Cancel',
  SIGN_IN_BUTTON: 'Sign In'
} as const

export const EMAIL_LOGIN_ERRORS = {
  NO_ACCESS_TOKEN: 'The service did not return an access token.',
  SERVER_ERROR_TITLE: 'Server Error'
} as const

export const ROLE_NAMES = {
  ADMINISTRATOR: 'Administrator',
  MEMBER: 'Member'
} as const

export const ROUTES = {
  USER_MANAGEMENT: '/user-management',
  APPROVALS: '/approvals',
  LOGIN: '/'
} as const

export const AUTOCOMPLETE_VALUES = {
  USERNAME: 'username',
  CURRENT_PASSWORD: 'current-password'
} as const
